<template>
	<div>
		<!-- <MyBread v-bind:BreadcrumbList="BreadcrumbList"></MyBread> -->

		<Form ref="formInline" :model="formInline" style="text-align: left;margin-top: 1%;" inline>
			<FormItem prop="keyword">
				<Input type="text" v-model="formInline.keyword" :placeholder="$tt('任务名称')"/>
			</FormItem>

			<FormItem prop="keyword">
				<Select clearable :placeholder="$tt('任务类型')"  v-model="formInline.switch">
				    <Option value="0">{{$tt('全部')}}</Option>
				    <Option value="1">{{$tt('在线')}}</Option>
				    <Option value="2">{{$tt('离线')}}</Option>
				</Select>
				
			</FormItem>

			<FormItem prop="keyword">
				<Select clearable :placeholder="$tt('任务状态')"  v-model="formInline.switch">
				    <Option value="0">{{$tt('全部')}}</Option>
				    <Option value="1">{{$tt('在线')}}</Option>
				    <Option value="2">{{$tt('离线')}}</Option>
				</Select>
			</FormItem>
			
			<FormItem>
				<Button type="primary" @click="handleSubmit('formInline')">{{$tt('查询')}}</Button>
			</FormItem>
			
			<div style="height: 50px;float: right;">
				<Button  type="primary" @click="show('addTrack')">{{$tt('新增')}}</Button>
			</div>
		</Form>



		<Table :row-class-name="rowClassName" :columns="columns1" :data="data1" size="small"></Table>



		<Page :total="pageTotal" :page-size="pageSize" size="small" :page-size-opts="opts" show-elevator show-sizer
		 @on-change="pageChange" @on-page-size-change="totalPageChange" />

		<!--新增追踪-->
		<Modal v-model="modal11" :title="modal.Title">



			<Form ref="TrackForm" :model="TrackForm" :rules="TrackFormRuler" :label-width="70">
				<FormItem :label="$tt('追踪名称')" prop="name">
					<Input v-model="TrackForm.name" :placeholder="$tt('输入设备id')"></Input>
				</FormItem>
				<FormItem :label="$tt('追踪MAC')" prop="mac">
					<Input v-model="TrackForm.mac" :placeholder="$tt('输入设备编号')"></Input>
				</FormItem>


			</Form>
			<div slot="footer">
				<Button type="warning" size="large" @click="modalCancel">{{$tt('重置')}}</Button>
				<Button type="success" size="large" @click="modalOk">{{$tt('确定')}}</Button>
			</div>
		</Modal>

		<!--地址报告-->
		<Modal fullscreen v-model="modal13" :title="modal.Title">
<Button type="warning" size="large" @click="exportReportAdd">{{$tt('导出地址报告')}}</Button>
			<Table style="margin-top: 2%;" border :columns="columns2" :data="data2" size="small"></Table>
			<Page style="margin-left: 40%;margin-top: 1%;" :total="pageTotalModal" :page-size="pageSizeModal" size="small"
			 :page-size-opts="opts" show-elevator show-sizer @on-change="pageChangeModal" @on-page-size-change="totalPageChangeModal" />

		</Modal>


		<!--查看报告&&感染链条-->
		<Modal v-model="modal12" fullscreen :title="modal.Title">
			
			<span v-if="modal.Title=='查看报告'">
				<Button type="warning" size="large" @click="exportReport">{{$tt('导出')}}</Button>
			<div style="font-size: 10px;" class="viewReport">
				<p>{{$tt('查询MAC')}}</p>
				<p>{{macName}}</p>
			</div>
			<div class="viewReport">
				<p>{{$tt('路过')}}</p>
				<p>{{passbyCount}}</p>
			</div>
			<div class="viewReport">
				<p>{{$tt('逗留')}}</p>
				<p>{{stayCount}}</p>
			</div>
			<div class="viewReport">
				<p>{{$tt('常驻')}}</p>
				<p>{{residentCount}}</p>
			</div>
		</span>
			<div id="tree" style="width: 1200px;height: 600px;margin-top: 6%;"></div>
		</Modal>
	</div>


</template>

<script>
	import Qs from 'qs'
	import echarts1 from "../../js/echarts_hot.js";
	import dateFormat from '../../../public/js/comm.js';
	export default {
		data() {
			return {
				taskId:'',
				
				//分页属性
				pageTotal: 60,
				pageSize: 10,
				opts: [10, 20, 30, 40],
				chectedPage: 1,

				pageTotalModal: 60,
				pageSizeModal: 10,
				chectedPageModal: 1,
				

				//模态对话框
				modal11: false,
				modal13: false,
				modal12: false,
				modal: {
					Title: this.$tt('追踪任务新增'),
					type: "addTracksx"
				},
				TrackForm: {
					name: '',
					mac: ''
				},
				TrackFormRuler: {
					name: [{
							required: true,
							message: this.$tt('此项不为空'),
							trigger: 'blur'
						}

					],
					mac: [{
						required: true,
						message: this.$tt('此项不为空'),
						trigger: 'blur'
					}]
				},


				//路过
				passbyCount: 4,
				//逗留
				stayCount: 6,
				//常驻
				residentCount: 23,
				macName:'',


				BreadcrumbList: [this.$tt('管理'), '>>', this.$tt('押解任务')],

				formInline: {
					keyword: '',
					status: false
				},

				//地址报告

				columns2: [{
						title: this.$tt('设备地址'),
						key: 'deviceAddr',
					}, {
						title: this.$tt('设备编号'),
						key: 'deviceCode',
					},
					{
						title: this.$tt('开始时间'),
						key: 'startTime',
						render: (h, params) => {
							return h('div', params.row.startTime == null ? "" : dateFormat.formatDate(new Date(params.row.startTime),
								'yyyy-MM-dd hh:mm'), )
						}
					},
					{
						title: this.$tt('结束时间'),
						key: 'endTime',
						render: (h, params) => {
							return h('div', params.row.endTime == null ? "" : dateFormat.formatDate(new Date(params.row.endTime),
								'yyyy-MM-dd hh:mm'), )
						}
					},
					{
						title: this.$tt('路过数量'),
						key: 'passbyCount'
					},
					{
						title: this.$tt('逗留数量'),
						key: 'stayCount'
					},
					{
						title: this.$tt('常驻数量'),
						key: 'residentCount'
					},
					{
						title: this.$tt('密切MAC明细'),
						key: 'detail'
					}
				],
				data2: [],

				columns1: [{
						title: this.$tt('序号'),
						key: 'id',
					}, {
						title: this.$tt('追踪名称'),
						key: 'name',
					},
					{
						title: this.$tt('追踪MAC'),
						key: 'mac'
					},
					{
						title: this.$tt('提交时间'),
						key: 'createTime',
						render: (h, params) => {
							return h('div', params.row.createTime == null ? "" : dateFormat.formatDate(new Date(params.row.createTime),
								'yyyy-MM-dd hh:mm'), )
						}
					},
					{
						title: this.$tt('是否有报告'),
						key: 'status'
					},
					{
						title: this.$tt('报告时间'),
						key: 'reportTime',

						render: (h, params) => {
							
							return h('div', params.row.reportTime == null ? "" : dateFormat.formatDate(new Date(params.row.reportTime),
								'yyyy-MM-dd hh:mm'), )
						}

					}, {
						title: this.$tt('操作'),
						key: 'action',
						width: 400,
						align: 'center',
						render: (h, params) => {
							return h('div', [
								h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										click: () => {
											this.show("report", params)
										}
									}
								}, this.$tt('查看报告')),
								h('Button', {
									props: {
										type: 'error',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										click: () => {
											this.show("addressReport", params)
										}
									}
								}, this.$tt('地址报告'))
							]);
						}
					}
				],
				data1: []
			};
		},
		created() {
			this.handleSubmit();
			
		},
		mounted() {},
		methods: {
			rowClassName: function(row, index) {
			
				if (index % 2 == 0) {
					return 'demo-table-info-row';
			
				} else if (index % 2 == 1) {
					return 'demo-table-error-row';
				}
				return '';
			},
			show: function(type, params) {
				if (type === "report") {
					this.modal.Title = this.$tt('查看报告');
					this.modal12 = true;
					this.getTreeData(params,"report");
					
				} else if (type === "addressReport") {
					this.modal.Title = this.$tt('地址报告');
					this.modal13 = true;
					this.handleSubmitModal(params.row.id);
				} else if (type === "infectionChain") {
					this.modal.Title = this.$tt('感染链条');
					this.modal12 = true;
						this.getTreeData(params,"report2");
				} else {
					//addTrack
					this.modal.Title = this.$tt('新增追踪任务');
					this.modal11 = true;
				}

			},
			pageChange: function(a) {
				
				this.chectedPage = a;
				this.handleSubmit();
			},
			totalPageChange: function(a) {
				this.pageSize = a;
				this.handleSubmit();
				
			},
			handleSubmit: function(formName) {
				const _this = this;
				let checked;
				checked = this.formInline.status == true ? 1 : 0;
				let parms = {
					page: this.chectedPage,
					pageSize: this.pageSize,
					keyword: this.formInline.keyword,
					status: checked
				}
				_this.$axios.post("/gateway/task/queryList", Qs.stringify(parms), {

				}).then(res => {

					if (res.data.status == 1) {
						res.data.data.list.map(data => {
							data.create = new Date(data.create);
							data.manufactureDate = new Date(data.manufactureDate);
						});
						_this.data1 = res.data.data.list;
						_this.pageTotal = res.data.data.total;
					}
				})


			},
			pageChangeModal: function(a) {

				this.chectedPageModal = a;
				this.handleSubmitModal(this.taskId);
			},
			totalPageChangeModal: function(a) {
				this.pageSizeModal = a;
				this.handleSubmitModal(this.taskId);
				
			},
			handleSubmitModal: function(params) {
				const _this = this;
				_this.taskId=params;
				let parms = {
					taskId:_this.taskId,
					page: this.chectedPageModal,
					pageSize: this.pageSizeModal,
					keyword: this.formInline.trackName
				}
				_this.$axios.post("/gateway/report/addr", Qs.stringify(parms), {

				}).then(res => {

					if (res.data.status == 1) {
						res.data.data.list.map(data => {
							data.startTime = new Date(data.startTime);
							data.endTime = new Date(data.endTime);

						});
						_this.data2 = res.data.data.list;
						_this.pageTotalModal = res.data.data.total;
					}else{
						_this.data2 = [];
					}
				})


			},







			modalCancel: function() {
				this.$refs.TrackForm.resetFields();
			},
			modalOk: function() {
				const _this = this;

				let parms = _this.TrackForm;

				_this.$refs.TrackForm.validate().then(res => {

					if (res) {
						_this.$axios.post("/gateway/task/add", parms, {

						}).then(res => {
							
							if (res.data.status == 1) {
								_this.$Message.success(this.$tt('添加成功'));

								_this.modal11 = false;
								_this.handleSubmit();
								_this.modalCancel();
							} else {
								_this.$Message.error(this.$tt('添加失败'));
							}
						})
					} else {
						_this.$Message.error(this.$tt('请通过校验后再次提交'));
					}
				})

			},

			getTreeData: function(params,type) {

				const _this = this;
				let url='';
				let taskId='';
				if(type=="report"){
					url="/gateway/report/detail"
					_this.taskId=params.row.id
				}else{
					url="/gateway/report/infectChain"
				}

				let parms = {
					taskId:_this.taskId
				}
				_this.$axios.post(url, Qs.stringify(parms), {

				}).then(res => {
				
					if (res.data.status == 1) {
						_this.$Message.success(this.$tt('查询成功'));
						if(type=="report"){
							_this.passbyCount=res.data.data.passbyCount;
							_this.residentCount=res.data.data.residentCount;
							_this.stayCount=res.data.data.stayCount;
							_this.macName=res.data.data.name;
							echarts1.initTree("tree", res.data.data.list);
						}else{
							_this.passbyCount=res.data.data.passbyCount;
							_this.residentCount=res.data.data.residentCount;
							_this.stayCount=res.data.data.stayCount;
							_this.macName=res.data.data.name;
							echarts1.initTree("tree", res.data.data.data[0]);
						}
					
						//echarts1.initTree("tree", _this);
						
						
						
					} else {
						_this.$Message.error(this.$tt('查询失败'));
						echarts1.initTree("tree",{});
					}
				})



			},
			exportReport: function(){
				const _this=this;
				_this.$axios
					.get("/gateway/report/exportMac", {
						params: {
							taskId:_this.taskId
						},
						 responseType: 'arraybuffer',
					})
					.then(response => {
						
						//	console.log(response.data);
						var blob = new Blob([response.data])
						var downloadElement = document.createElement('a');
						　　var href = window.URL.createObjectURL(blob); //创建下载的链接
						　　downloadElement.href = href;
						　　downloadElement.download = 'mac报告.xlsx'; //下载后文件名
						　　document.body.appendChild(downloadElement);
						　　downloadElement.click(); //点击下载
						　　document.body.removeChild(downloadElement); //下载完成移除元素
						　　window.URL.revokeObjectURL(href); //释放掉blob对象 
				
				
				
					});
			},
			
			exportReportAdd: function(){
				const _this=this;
				_this.$axios
					.get("/gateway/report/exportAddr", {
						params: {
							taskId:_this.taskId
						},
						 responseType: 'arraybuffer',
					})
					.then(response => {
						
						//	console.log(response.data);
						var blob = new Blob([response.data])
						var downloadElement = document.createElement('a');
						　　var href = window.URL.createObjectURL(blob); //创建下载的链接
						　　downloadElement.href = href;
						　　downloadElement.download = '地址报告.xlsx'; //下载后文件名
						　　document.body.appendChild(downloadElement);
						　　downloadElement.click(); //点击下载
						　　document.body.removeChild(downloadElement); //下载完成移除元素
						　　window.URL.revokeObjectURL(href); //释放掉blob对象 
				
				
				
					});
			}
			
		},
		


	}
</script>

<style>
	.viewReport {
		float: left;
		width: 150px;
		height: 100px;

		font-size: 20px;
		text-align: center;
		background: linear-gradient(#f8f8f9, rgba(0, 0, 0, .2));
		margin-left: 10px;

	}

	.ivu-modal-content {
		background: linear-gradient(#f8f8f9, rgba(45, 140, 240, .2));

	}

	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */
</style>
